import React from 'react';

import HomeComponent from './HomeComponent';

export const Home = () => {
    return <HomeComponent />;
};

export default Home;
